import React, { useState, useEffect } from "react";
import "./styles.scss";
import CustomButton from "../../UI/CustomButton/inedx";

export default function WelcomePopup({ handleSave }) {
  return (
    <div className="welcome-modal-wrapper">
      <h1 className="welcome-modal-text"> Welcome to Sotira! </h1>

      <p className="welcome-modal-description">
        This breif guide will walk you through how to use the platform{" "}
      </p>

      <CustomButton className="start-btn" onClick={handleSave}>
        Start
      </CustomButton>
    </div>
  );
}
